var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-popup__dialog" },
    [
      _c("TripleEyeHeader"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isTest,
              expression: "!isTest"
            }
          ],
          staticClass: "cart-popup__content height-auto"
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isTest,
              expression: "!isTest"
            }
          ],
          staticClass: "cart-popup__item-link"
        },
        [
          _c(
            "button",
            {
              staticClass: "bt-akl-blue bt-eyecare-pop-orange",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.isTest = true
                }
              }
            },
            [_vm._v("결과보기")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isTest,
              expression: "isTest"
            }
          ],
          staticClass: "cart-popup__content height-auto"
        },
        [_vm._m(1)]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isTest,
              expression: "isTest"
            }
          ],
          staticClass: "cart-popup__item-link"
        },
        [
          _c(
            "button",
            {
              staticClass: "bt-akl-blue bt-eyecare-pop-orange",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("clickNext")
                }
              }
            },
            [_vm._v("다음으로")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_eyecare" }, [
      _c("div", { staticClass: "marB" }, [
        _c("p", { staticClass: "eyecare_tit" }, [
          _c("b", { staticClass: "color_orange" }, [
            _vm._v("1. 나는 황반변성인가? ")
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "eyecare_txt" }, [
          _vm._v(
            "\n          황반변성이 진행되면 그전으로 되돌리는 것에 어려움이 있으므로 미리 확인하고 예방하는 것이 중요합니다."
          ),
          _c("br"),
          _vm._v(" 아래 그림을 통해 황반변성 자가 테스트를 해보세요.\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "eyecare_list color_black" }, [
          _c("ul", [
            _c("li", [_vm._v("· 안경을 사용하시는 경우 착용하세요.")]),
            _vm._v(" "),
            _c("li", [_vm._v("· 약 30cm 떨어진 상태에서 격자 무늬를 보세요.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("· 한 눈 씩 가리고 중심에 있는 검은 점을 보세요.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "· 검은 점을 보면서 주변의 선들이 곧게 보이는지 확인하세요."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "txtC marB padT" }, [
          _c("img", {
            staticStyle: { "max-width": "400px", width: "100%" },
            attrs: {
              src:
                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/02_cont_01.png",
              alt:
                "네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음"
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "eyecare_comment" }, [
          _vm._v("\n          출처: 한국망막학회"),
          _c("br"),
          _vm._v(
            "\n          “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,\n          정확한 진단을 위해서는 의사와 상담이 필요합니다.”\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            color: "#aaa",
            "font-size": "9px",
            "text-align": "right"
          }
        },
        [_vm._v("CN001953")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_eyecare" }, [
      _c("div", { staticClass: "marB" }, [
        _c("p", { staticClass: "eyecare_tit" }, [
          _c("b", { staticClass: "color_orange" }, [
            _vm._v("1. 나는 황반변성인가? ")
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "eyecare_txt color_black" }, [_vm._v("만약!")]),
        _vm._v(" "),
        _c("div", { staticClass: "eyecare_list" }, [
          _c("ul", [
            _c("li", [_c("b", [_vm._v("- 가운데 점이 잘 보이지 않거나")])]),
            _vm._v(" "),
            _c("li", [
              _c("b", [_vm._v("- 선들이 휘어 보이고 끊어져 보이거나")])
            ]),
            _vm._v(" "),
            _c("li", [_c("b", [_vm._v("- 안보이는 부분이 있으시면")])])
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "eyecare_txt2" }, [
          _c("b", { staticClass: "color_red" }, [_vm._v("황반변성을 의심")]),
          _vm._v("해 볼 수 있습니다."),
          _c("br"),
          _vm._v(" 이때는 빨리 병원을 찾아 정확한 검사를 받아보세요.\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "txtC marB padT" }, [
          _c("img", {
            attrs: {
              src:
                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/03_cont_01.png",
              alt:
                "정상인 경우(네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음 : 그대로 보임), 황반변성 이상증상(네모 격자 무늬, 가운데 가로 세로 굵은 선이 있고, 만나는 곳에 점이 있음 : 일부분이 찌그러지고 그 중심 부분이 멍들어 보임)"
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "eyecare_comment" }, [
          _vm._v("\n          출처: 한국망막학회"),
          _c("br"),
          _vm._v(
            "\n          “본 자가진단은 증상의 조기발견을 도와 주기 위한 것으로,\n          정확한 진단을 위해서는 의사와 상담이 필요합니다.”\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            color: "#ccc",
            "font-size": "9px",
            "text-align": "right"
          }
        },
        [_vm._v("CN001953")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da6fd224", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da6fd224","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/triple-eye-care/component/quest1.vue
// module id = null
// module chunks = 